import React from 'react';
import { Row, Col } from 'reactstrap';
import MainMenu from '../Navigation/MainMenu/MainMenu';
import KeyVisual from '../UI/ResponsiveImageSet/ResponsiveImageSet';
import KeyVisualXs from '../../assets/images/keyvisual-xs-rgb.webp';
import KeyVisualLg from '../../assets/images/keyvisual-lg-rgb.webp';
import Countdown from './Countdown/Countdown';
import PageNotFoundHeader from './PageNotFoundHeader';
import CampaignMetrics from '../CampaignMetrics/CampaignMetrics';

const header = (props) => (
    <>
        <Row className="sticky-top">
            <Countdown />
        </Row>
        <Row>
            <Col className="p-0">
                <MainMenu
                    primaryNavigation={props.primaryNavigation}
                    primaryNavigationCTA={props.primaryNavigationCTA}
                />
            </Col>
        </Row>
        <Row>
            <Col className="px-0">
                {props.pageNotFound ? (
                    <PageNotFoundHeader />
                ) : (
                    <KeyVisual imageXs={KeyVisualXs} imageLg={KeyVisualLg} />
                )}
            </Col>
        </Row>
        <CampaignMetrics />
    </>
);

export default header;
